import { Modal, Button, Tooltip } from "antd";
import React, { useState } from "react";
import { connect } from "react-redux";
import { showPopup } from "../../../redux/action/common";
import "./style.css";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  RedditShareButton,

  // Comment to sepaate, overwriting codesandbox behavior
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
  RedditIcon,
} from "react-share";

const ShareEventPopup = (props) => {
  const { showPopup, popupData } = props;
  const [copyText, setCopyText] = useState(popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy : "Copy");
  console.log(popupData?.eventDetailSection);
  return (
    <Modal className="sach-modal-share" centered visible={true} onCancel={() => showPopup(null)} footer={null}>
      <div className="sach-title indv">
        <h4>{popupData && popupData.eventDetailSection && popupData.eventDetailSection.shareLink ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.shareLink : "Share a link"}</h4>
      </div>
      <div className="row g-0 share-icons">
        <div className="col">
          <EmailShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <EmailIcon round />
          </EmailShareButton>
          <b>Email</b>
        </div>
        <div className="col">
          <FacebookShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <FacebookIcon round />
          </FacebookShareButton>
          <b>Facebook</b>
        </div>
        <div className="col">
          <WhatsappShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <WhatsappIcon round />
          </WhatsappShareButton>
          <b>Whatsapp</b>
        </div>
        <div className="col">
          <TwitterShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <TwitterIcon round />
          </TwitterShareButton>
          <b>Twitter</b>
        </div>
        <div className="col">
          <LinkedinShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <LinkedinIcon round />
          </LinkedinShareButton>
          <b>LinkedIn</b>
        </div>
        <div className="col">
          <RedditShareButton url={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)}>
            <RedditIcon round />
          </RedditShareButton>
          <b>Reddit</b>
        </div>
      </div>
      <div className="input-group">
        <input type="text" className="form-control" placeholder="Share link" readonly value={popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl)} />
        <Tooltip placement="top" title={copyText} mouseLeaveDelay={0}>
          <Button
            className="btn btn-outline-secondary"
            onClick={() => {
              navigator.clipboard.writeText(popupData?.shareLink + "&cl=" + (popupData?.cl === undefined ? Math.floor(Math.random() * 4) + 1 : popupData?.cl));
              setCopyText(popupData && popupData.eventDetailSection && popupData.eventDetailSection.linkCopy ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.linkCopy : "Link Copied!");
            }}
            onBlur={() => setCopyText(popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy : "Copy")}
            onMouseLeave={() => setCopyText(popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy : "Copy")}
          >
            {popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy ? popupData && popupData.eventDetailSection && popupData.eventDetailSection.copy : "Copy"}
          </Button>
        </Tooltip>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
    commonData: state?.CommonReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showPopup: (type, data) => dispatch(showPopup(type, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareEventPopup);
